import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import "../adminProfile/adminProfile.css";
import {
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  InputAdornment,
} from "@mui/material";
import { useAuth } from "../../context/API_Client";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import UploadLogo from "./uploadLogo";
import CustomButton from "../../reusableComponents/CustomButton";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import "../analytics/analytics.css";
import { useEditButtonContext } from "./EditButtonContext";
import { nameRegex } from "../../reusableComponents/constants";
import FileCopyIcon from "../../../assets/svg/fileCopy.svg";
import { colorBrandObject } from "../../../constants/brandings";
import { fileCopyDefaultColor } from "../../reusableComponents/constants";

function BusinessInfo() {
  const {
    updateCheckoutSettings,
    merchantSettings,
    merchantLogo,
    merchantName,
  } = useAuth();
  const [getMerchantSettings, setMerchantSettings] = useState([]);
  const [open, setOpen] = useState(false);
  const [companyname, setcompanyname] = useState("");
  const [dropdownContent, setDropdownContent] = React.useState("");
  const [editChange, setEditChange] = useState(false);
  const [disabledBrandName, setDisabledBrandname] = useState(true);
  const [disabledTimeZone, setDisabledTimeZone] = useState(true);
  const [disabledWebsiteAddress, setDisabledWebsiteAddress] = useState(true);
  const [disabledEmail, setDisabledEmail] = useState(true);
  const [merchantID, setMerchantID] = useState("");
  const [websiteAddress, setWebsiteAddress] = useState("");

  const { isEditing, activeEditingPage, startEditing, stopEditing } =
    useEditButtonContext();

  const handleChange = (event) => {
    const value = event.target.value;
    setDropdownContent(value);
  };

  const schema = yup.object({
    companyName: yup
      .string()
      .required("Please enter brand name")
      .matches(nameRegex, "Please enter valid brand name"),
    email: yup
      .string()
      .trim()
      .matches(
        /(^$)|^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,})$/,
        "Please enter a valid email address"
      ),
    websiteAddress: yup
      .string()
      .trim()
      .nullable()
      .notRequired()
      .test(
        "is-website-address",
        "Please enter a valid website address",
        function (value) {
          if (!value) return true;
          const websiteRegex = /^(?!http:\/\/)[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?$/i;
          return websiteRegex.test(value);

        }
      ),
  });

  const { handleSubmit, control, formState, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleEdit = () => {
    setEditChange(!editChange);
    startEditing("businessInfo");
    setMerchantID(getMerchantSettings?.merchantId);
    setcompanyname(getMerchantSettings?.merchantName);
    setWebsiteAddress(getMerchantSettings?.websiteAddress);
    setValue("companyName", getMerchantSettings?.merchantName);
    setValue("websiteAddress", getMerchantSettings?.websiteAddress?.substring(8));
    setValue("email", getMerchantSettings?.email);
    getMerchantSettings?.timeZone == "IST"
      ? setDropdownContent("IST (UTC + 5:30)")
      : setDropdownContent("GMT (UTC - 5:00)");
    setversionBI(getMerchantSettings?.version);

    setDisabledBrandname(!disabledBrandName);
    setDisabledTimeZone(!disabledTimeZone);
    setDisabledWebsiteAddress(!disabledWebsiteAddress);
    setDisabledEmail(!disabledEmail);
    formState.errors.companyName = false;
  };

  const handleSavedChanges = () => {
    setEditChange(!editChange);
    stopEditing();
    setDisabledBrandname(!disabledBrandName);
    setDisabledTimeZone(!disabledTimeZone);
    setDisabledWebsiteAddress(!disabledWebsiteAddress);
    setDisabledEmail(!disabledEmail);

    customToast("success", "high", "Changes Saved");
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(merchantID);
    customToast("success", "medium", "Copied to clipboard");
  };

  const handleCancel = () => {
    setEditChange(!editChange);
    stopEditing();
    setMerchantID(getMerchantSettings?.merchantId);
    setcompanyname(getMerchantSettings?.merchantName);
    setWebsiteAddress(getMerchantSettings?.websiteAddress);
    setValue("companyName", getMerchantSettings?.merchantName);
    setValue(
      "websiteAddress",
      getMerchantSettings?.websiteAddress
        ? getMerchantSettings?.websiteAddress?.substring(8)

        : ""
    );
    setValue("email", getMerchantSettings?.email);
    getMerchantSettings?.timeZone == "IST"
      ? setDropdownContent("IST (UTC + 5:30)")
      : setDropdownContent("GMT (UTC - 5:00)");
    setversionBI(getMerchantSettings?.version);

    setDisabledBrandname(!disabledBrandName);
    setDisabledTimeZone(!disabledTimeZone);
    setDisabledWebsiteAddress(!disabledWebsiteAddress);
    setDisabledEmail(!disabledEmail);
    formState.errors.companyName = false;
    formState.errors.email = "";
  };

  const [timezone, settimezone] = useState("");
  const [versionBI, setversionBI] = useState();
  const [logoUrl, setLogoUrl] = useState("");

  useEffect(() => {
    merchantSettings(
      function (data) {
        setMerchantSettings(data);
      },
      function (errorMsg) { }
    );
  }, [logoUrl]);

  useEffect(() => {
    setMerchantID(getMerchantSettings?.merchantId);
    setcompanyname(getMerchantSettings?.merchantName);
    setValue("companyName", getMerchantSettings?.merchantName);
    const websiteAddressTrimmed = getMerchantSettings?.websiteAddress?.substring(8);
    setValue("websiteAddress", websiteAddressTrimmed);
    setValue("email", getMerchantSettings?.email);
    setWebsiteAddress(getMerchantSettings?.address);
    setversionBI(getMerchantSettings?.version);
    setLogoUrl(getMerchantSettings?.logoUrl);

    getMerchantSettings?.timeZone == "IST"
      ? setDropdownContent("IST (UTC + 5:30)")
      : setDropdownContent("GMT (UTC - 5:00)");
  }, [timezone, companyname, getMerchantSettings]);

  const onSubmit = (formData, event) => {
    var timeZone = dropdownContent.substring(0, 3);
    var version = versionBI;
    if (formData?.websiteAddress) {
      formData.websiteAddress = 'https://' + formData.websiteAddress;
    }
    let payload = {
      websiteAddress: formData?.websiteAddress,
      merchantName: formData?.companyName,
      email: formData?.email,
      timeZone,
      version,
    }
    updateCheckoutSettings(
      payload,
      function (data) {
        getMerchantSettings.merchantName = formData.companyName;
        getMerchantSettings.websiteAddress = formData.websiteAddress;
        getMerchantSettings.email = formData.email;
        getMerchantSettings.timeZone = timeZone;
        getMerchantSettings.version = data.version;

        setcompanyname(getMerchantSettings?.merchantName);
        setWebsiteAddress(getMerchantSettings?.websiteAddress);
        setversionBI(getMerchantSettings?.version);

        getMerchantSettings?.timeZone == "IST"
          ? setDropdownContent("IST (UTC + 5:30)")
          : setDropdownContent("GMT (UTC - 5:00)");
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );

    handleSavedChanges();
  };

  useEffect(() => {
    merchantSettings(
      function (data) {
        setMerchantSettings(data);
      },
      function (errorMsg) { }
    );
  }, [companyname]);

  const generateRandomString = (length) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }
    return result;
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
        <div className="mainDivCreateform">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography className="subHeaderMedium font-black-highest">
              Business Information
            </Typography>
            <div>
              {editChange ? (
                <div style={{ display: "flex" }}>
                  <div style={{ paddingRight: "20px" }}>
                    <CustomButton
                      text={"Cancel"}
                      type={"primary"}
                      size={"sm"}
                      onClick={handleCancel}
                    />
                  </div>
                  <CustomButton
                    text={formState.isSubmitting ? "Saving..." : "Save Changes"}
                    type={"primary"}
                    size={"sm"}
                    variant={"contained"}
                    onClick={handleSubmit(onSubmit)}
                    disabled={formState.isSubmitting}
                  />
                </div>
              ) : (
                <CustomButton
                  text={"Edit Info"}
                  type={"primary"}
                  variant={"contained"}
                  size={"sm"}
                  onClick={handleEdit}
                  disabled={isEditing && activeEditingPage === "personalInfo"}
                />
              )}
            </div>
          </div>
          <div
            className="titleCreate"
            style={{ flexDirection: "row", marginTop: "30px" }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
              }}
            >
              <img
                src={
                  merchantLogo == "" || !merchantLogo
                    ? "/assets/cameraIcon.svg"
                    : merchantLogo
                }
                alt="icon"
                className="iconStyleCreate"
                style={{
                  height: "60px",
                  width: "60px",
                  borderRadius: "50%",
                  border: "3px  solid #E1E1E1",
                }}
              />
              <ul className="navbar-nav ml-auto">
                <li className="nav-item dropdown user-menu">
                  <a
                    style={{
                      height: "5px",
                      width: "5px",
                      borderRadius: "50%",
                      display: "flex",
                    }}
                    href="#"
                    className="nav-link dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div>
                      <img
                        src="/assets/editIcon2.svg"
                        alt="User Image"
                        style={{
                          height: "20px",
                          width: "20px",
                          marginLeft: "-20px",
                          marginBottom: "-80px",
                          background: "white",
                          borderRadius: "50%",
                        }}
                      />
                    </div>
                  </a>

                  <ul
                    className="dropdown-menu dropdown-menu-right"
                    style={{
                      width: "60px",
                      marginTop: "45px",
                      borderTopLeftRadius: "4px",
                      borderTopRightRadius: "4px",
                    }}
                  >
                    <div>
                      <MenuItem
                        value="Upload Logo"
                        onClick={handleOpen}
                        style={{ fontSize: "16px", fontFamily: "Poppins" }}
                      >
                        Upload Logo
                      </MenuItem>
                    </div>
                  </ul>
                </li>
              </ul>
            </div>
            <div
              style={{
                flexDirection: "column",
                display: "flex",
                marginTop: "8px",
              }}
            >
              <div className="firstTitle">{companyname}</div>
              <div style={{ color: "gray", fontSize: "15px" }}>
                Upload your company’s logo here
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              marginTop: "28px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "45%" }}>
              <InputLabel className="fontCreate" style={{ color: "#547187" }}>
                Merchant ID
              </InputLabel>
              <Controller
                name="merchantID"
                control={control}
                render={({ field }) => (
                  <OutlinedInput
                    {...field}
                    className="textFieldCreate"
                    size="small"
                    name="merchantID"
                    style={{ color: "gray", width: "100%" }}
                    value={merchantID}
                    disabled={true}
                    aria-describedby="outlined-title-helper-text"
                    endAdornment={
                      <InputAdornment
                        position="end"
                        onClick={() => handleCopy()}
                        style={{ cursor: "pointer" }}
                      >
                        <div style={{ stroke: fileCopyDefaultColor }}>
                          <FileCopyIcon stroke={`${colorBrandObject?.primaryButtonColor}`} style={{ cursor: "pointer" }} />
                        </div>
                      </InputAdornment>
                    }
                  />
                )}
              />
            </div>
            <div style={{ width: "45%" }}>
              <InputLabel
                htmlFor="companyName"
                className="fontCreate"
                style={{ color: "#547187" }}
                required={true}
              >
                Brand Name
              </InputLabel>
              <Controller
                name="companyName"
                control={control}
                render={({ field }) => (
                  <OutlinedInput
                    {...field}
                    className="textFieldCreate"
                    id="companyName"
                    size="small"
                    name="companyName"
                    style={{
                      color: disabledBrandName ? "gray" : "black",
                      width: "100%",
                    }}
                    disabled={disabledBrandName}
                    aria-describedby="outlined-title-helper-text"
                  />
                )}
              />
              {formState.errors.companyName && (
                <div
                  className="error"
                  style={{
                    color: "#B9232F",
                    fontSize: "10px",
                    marginTop: "2px",
                  }}
                >
                  <img
                    src="/assets/errorOutline.svg"
                    style={{ height: "12px", width: "12px" }}
                  />{" "}
                  {formState.errors.companyName.message}
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              marginTop: "28px",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{ width: "45%" }}
              className={
                disabledWebsiteAddress ? "disabledColor" : "enabledColor"
              }
            >
              <InputLabel className="fontCreate" style={{ color: "#547187" }}>
                Website Address
              </InputLabel>
              <Controller
                name="websiteAddress"
                control={control}
                render={({ field }) => (
                  <OutlinedInput
                    {...field}
                    className="textFieldCreate"
                    id="websiteAddress"
                    size="small"
                    name="websiteAddress"
                    startAdornment={
                      <InputAdornment position="start">https://</InputAdornment>
                    }
                    style={{
                      color: disabledWebsiteAddress ? "gray" : "black",
                      width: "100%",
                    }}
                    onChange={(e) => {
                      const { value } = e.target;
                      if (value.startsWith("https://")) {
                        const trimmedValue = value.substring(8);
                        field.onChange(trimmedValue);
                      } else {
                        field.onChange(value);
                      }
                    }}
                    disabled={disabledWebsiteAddress}
                    aria-describedby="outlined-title-helper-text"
                  />
                )}
              />

              {formState.errors.websiteAddress && (
                <div
                  className="error"
                  style={{
                    color: "#B9232F",
                    fontSize: "10px",
                    marginTop: "2px",
                  }}
                >
                  <img
                    src="/assets/errorOutline.svg"
                    style={{ height: "12px", width: "12px" }}
                  />{" "}
                  {formState.errors.websiteAddress.message}
                </div>
              )}
            </div>
            <div style={{ width: "45%" }}>
              <InputLabel className="fontCreate" style={{ color: "#547187" }}>
                Support Email
              </InputLabel>

              <Controller
                name="email"
                control={control}
                render={({ field }) => (
                  <OutlinedInput
                    {...field}
                    className="textFieldCreate"
                    name="email"
                    size="small"
                    id="email"
                    aria-describedby="outlined-title-helper-text"
                    style={{
                      color: disabledEmail ? "gray" : "black",
                      width: "100%",
                    }}
                    disabled={disabledEmail}
                  />
                )}
              />

              {formState.errors.email && (
                <div
                  style={{
                    color: "#B9232F",
                    fontSize: "10px",
                    marginTop: "2px",
                  }}
                >
                  <img
                    src="/assets/errorOutline.svg"
                    style={{ height: "12px", width: "12px" }}
                  />{" "}
                  {formState.errors.email.message}
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              marginTop: "28px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "45%" }}>
              <InputLabel className="fontCreate" style={{ color: "#547187" }}>
                Preferred Timezone
              </InputLabel>
              <Controller
                name="timeZone"
                control={control}
                render={({ field }) => (
                  <div>
                    <Select
                      {...field}
                      className="textFieldCreate"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{
                        color: disabledTimeZone ? "gray" : "black",
                        width: "100%",
                      }}
                      disabled={disabledTimeZone}
                      value={dropdownContent}
                      onChange={(e) => handleChange(e)}
                    >
                      <MenuItem value="IST (UTC + 5:30)">
                        IST (UTC + 5:30)
                      </MenuItem>
                      <MenuItem value="GMT (UTC - 5:00)">
                        GMT (UTC - 5:00)
                      </MenuItem>
                    </Select>
                  </div>
                )}
              />
            </div>
          </div>
        </div>
        <UploadLogo
          open={open}
          onClose={handleClose}
          setLogoUrl={setLogoUrl}
          versionBI={versionBI}
          setversionBI={setversionBI}
        />
      </form>
    </>
  );
}

export default BusinessInfo;